const LeftSideLayout = (props) => {

    return (
        <>
            {props.children}
        </>
    );
}

export default LeftSideLayout;